<template>
  <div class="engine-data-event-summary">
    <div id="container">
      <recycle-scroller
        :items="eventsData"
        v-slot="{ item:event }"
        key-field="index"
        :min-item-size="80"
        class="sdf-recycle-scroller"
      >
        <div
          class="row"
          :class="addColorClass(event)"
        >
          <div class="column-date">
            {{formatTime(event.channel_time)}}
          </div>
          <div class="column-id">
            {{event.channel_id}}
          </div>
          <div class="column-event-name">
            {{event.channel_name}}
          </div>
          <div class="column-event-value">
            {{event.value_number ? event.value_number : event.value_string}}
          </div>
          <div class="column-unit">
            {{event.unit}}
          </div>
          <div class="column-event-status">
            {{event.status ? event.status.replace("E", "") : event.status}}
          </div>
        </div>
      </recycle-scroller>
    </div>
  </div>
</template>

<script>
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin";
import {
  StoreCommonsMixin,
  StoreMenuMixin,
  MappingTableMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";
import SecureDataflowService from "@/services/secureDataflowService";
import { createNamespacedHelpers } from "vuex";
import { ChannelDataUtil } from "@/utils/secure-dataflow"
import SdfPopup from "../../components/SdfPopup";
import _ from "lodash";
import moment from "moment";
const { mapGetters, mapState, mapActions } = createNamespacedHelpers(
  "monitoringVesselEngine"
);
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
  name: "engineDataEventSummary",
  mixins: [
    StoreCommonsMixin,
    StoreMenuMixin,
    SecureDataflowMixin,
    MappingTableMixin,
    StoreMonitoringVesselManeuveringMixin
  ],
  props: [
    'showNormalValue',
    'showAbnormalValue',
    'liveModeSortOrder',
    'dateModeSortOrder'
  ],
  components: {
    SdfPopup,
    RecycleScroller,
  },
  data() {
    return {
      inputChannelNumber: "",
      popupActive: false,
      popupButtonStyle: `
        padding: 5px !important;
        margin-right: 15px;
      `,
    }
  },
  computed: {
    ...mapGetters(["getEventSummaryData"]),
    ...mapState({
      eventSummaryLiveDatas: state => state.eventSummaryLiveDatas,
      mode: state => state.mode,
    }),
    eventsData() {
      let eventSummaryData = [...this.getEventSummaryData]
      if (this.mode === "live") {
        if (this.liveModeSortOrder == "asc") {
          eventSummaryData = this.filterEventsByStatus(this.eventSummaryLiveDatas.concat(eventSummaryData.reverse())).reverse()
        } else if (this.liveModeSortOrder == "desc") {
          eventSummaryData =  this.filterEventsByStatus(this.eventSummaryLiveDatas.concat(eventSummaryData.reverse()))
        }
      } else {
        if (this.dateModeSortOrder == "asc") {
          eventSummaryData = this.filterEventsByStatus(eventSummaryData)
        } else if (this.dateModeSortOrder == "desc") {
          eventSummaryData = this.filterEventsByStatus(eventSummaryData).reverse()
        }
      }
      return eventSummaryData.map((element, index) => {
        return {...element, index: index}
      })
    },
  },
  methods: {
    ...mapActions([
      "setModeState",
      "setChannelTimeFromState",
      "setChannelTimeToState",
      "getChannelMaster",
      "setChannelsDataSearchedByStatus",
      "clearLocalDbChannelData",
      "resetEventSummaryLiveDatas",
      "subscribeChannelDataEngine",
      "unsubscribeFirestore",
      "setOriginIdState",
      "initializeCustomChannelIds",
      "setReferencedChannelIdMap",
    ]),
    /**
     * ライブデータを取得
     */
    async submitLiveMode(forceFlg) {
      if (this.getMode !== "live" || forceFlg === true) {

        this.openLoading();
        this.$nextTick(async () => {

          await this.clearLocalDbChannelData();
          await this.setReferencedChannelIdMap({});

          await this.setModeState("live");
          await this.setChannelTime("live");

          this.$vs.loading.close('#content-area > .con-vs-loading');
        });
      }
    },
    /**
     * モードに合わせて開始終了時間をstate保存
     */
    async setChannelTime(mode) {
      let time_from = null;
      let time_to = null;
      if (mode === "live") {
        let liveDataTimeRange = this.liveDataTimeRange ? this.liveDataTimeRange : 60;
        time_from = moment().subtract(liveDataTimeRange, "minutes").format("YYYY-MM-DDTHH:mm:ss.000");
        time_to   = moment().format("YYYY-MM-DDTHH:mm:ss.000");
      } else {
        time_from = moment(this.targetDate).format("YYYY-MM-DD") + "T" + this.startTime + ".000";
        time_to   = moment(this.targetDate).format("YYYY-MM-DD") + "T" + this.endTime   + ".000";
      }

      await this.setChannelTimeFromState(moment(time_from).toISOString());
      await this.setChannelTimeToState(  moment(time_to  ).toISOString());
    },
    filterEventsByStatus(events) {
      let filteredEvents = events
      if (!this.showNormalValue) {
        filteredEvents = filteredEvents.filter(event => this.isAbnormalMachinery(event.status))
      }
      if (!this.showAbnormalValue) {
        filteredEvents = filteredEvents.filter(event => !this.isAbnormalMachinery(event.status))
      }
      return filteredEvents
    },
    openLoading(){
      this.$vs.loading({
        text: "データ取得中",
        textAfter: true,
        color: this.sdfColor.Blue,
        container: '#content-area',
      })
      setTimeout( ()=> {
        this.$vs.loading.close('#content-area > .con-vs-loading')
      }, 2000);
    },
    formatTime(time) {
      return moment(time).format("YYYY/MM/DD HH:mm:ss")
    },
    displayPopup () {
      this.popupActive = true
    },
    isAbnormalMachinery (status) {
      return ChannelDataUtil.isAbnormalMachinery(status)
    },
    isFirstStringOption (valueString, stringOptions) {
      let stringOptionsArray = stringOptions ? stringOptions.split("/") : [];
      if (stringOptionsArray.length != 0 && stringOptionsArray[0] == valueString) {
        return true
      } else {
        return false
      }
    },
    addColorClass(event) {
      if (this.isAbnormalMachinery(event.status)) {
        return 'sdf-text-20-400-red'
      } else if (this.isFirstStringOption(event.value_string, event.value_string_options)) {
        return 'sdf-text-20-400-green'
      } else {
        return 'sdf-text-20-400-white'
      }
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/_variables.scss";
.engine-data-event-summary {
  width: 100%;
  .row {
    display: flex;
    height: 80px;
    align-items: center;
    border-bottom: solid 0.5px $gray;
  }

  .button-3d {
    padding: 0px 13px !important;
    border-radius: 15px;
  }
  .popup-input {
    margin-top: 30px;
    margin-bottom: 30px;
    input {
      background: transparent;
      border-color: $white !important;
    }
    .vs-input--placeholder {
      color: $white;
    }
  }
  .popup-title {
    margin-left: 30px;
  }
  .popup-button {
    padding: 5px !important;
  }
  .sdf-popup-container {
    width: 300px;
  }
  .sdf-recycle-scroller {
    overflow-y: auto;
    height: calc(100vh - 299px);
  }
}
</style>
